"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTextProperty = exports.textPropertyDefinition = void 0;
exports.textPropertyDefinition = {
    view: { label: 'Text' },
    constraints: [],
    type: 'rich-text',
    multiple: false,
    name: 'text',
};
const isTextProperty = (prop) => {
    return prop.name === exports.textPropertyDefinition.name;
};
exports.isTextProperty = isTextProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3RleHQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQkFBc0IsR0FBRztJQUNwQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFO0lBQ3ZCLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsTUFBTTtDQUNtQixDQUFBO0FBSTFCLE1BQU0sY0FBYyxHQUFHLENBQUMsSUFBa0IsRUFBd0IsRUFBRTtJQUN6RSxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssOEJBQXNCLENBQUMsSUFBSSxDQUFBO0FBQ2xELENBQUMsQ0FBQTtBQUZZLFFBQUEsY0FBYyxrQkFFMUIifQ==